export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8552.27ad16fb.jpg";